import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { getViewportWidth } from '@lemonadefashion/viewport';

export const CONTAINER_WIDTH_768 = 724;
export const CONTAINER_WIDTH_992 = 936;
export const CONTAINER_WIDTH_1200 = 1128;
export const CONTAINER_WIDTH_1400 = 1316;
export const CONTAINER_WIDTH_1600 = 1504;
export const CONTAINER_MOBILE_MARGIN = 16;

export function fullMobileContainerWidthCSSString() {
  return `100vw - 2 * ${CONTAINER_MOBILE_MARGIN}px`;
}

export function percentageMobileContainerWidthCSSString(ratio) {
  return `(${fullMobileContainerWidthCSSString()}) * ${ratio}`;
}

export function getContainerWidthAtViewportWidth(viewportWidth) {
  if (viewportWidth >= 1600) return CONTAINER_WIDTH_1600;
  if (viewportWidth >= 1400) return CONTAINER_WIDTH_1400;
  if (viewportWidth >= 1200) return CONTAINER_WIDTH_1200;
  if (viewportWidth >= 992) return CONTAINER_WIDTH_992;
  if (viewportWidth >= 768) return CONTAINER_WIDTH_768;
  return viewportWidth - 2 * CONTAINER_MOBILE_MARGIN;
}

export function getPercentageContainerWidthCSSStringAtViewportWidth(viewportWidth, ratio) {
  if (viewportWidth >= 1600) return `${Math.floor(CONTAINER_WIDTH_1600 * ratio)}px`;
  if (viewportWidth >= 1400) return `${Math.floor(CONTAINER_WIDTH_1400 * ratio)}px`;
  if (viewportWidth >= 1200) return `${Math.floor(CONTAINER_WIDTH_1200 * ratio)}px`;
  if (viewportWidth >= 992) return `${Math.floor(CONTAINER_WIDTH_992 * ratio)}px`;
  if (viewportWidth >= 768) return `${Math.floor(CONTAINER_WIDTH_768 * ratio)}px`;
  return `${Math.floor((viewportWidth - 2 * CONTAINER_MOBILE_MARGIN) * ratio)}px`;
}

export function getCurrentContainerWidth() {
  return getContainerWidthAtViewportWidth(getViewportWidth());
}

const UIContainer = ({ paddingTop, position, zIndex, containerTop, containerBottom, children, ...rest }) => (
  <ContainerElement paddingTop={paddingTop} position={position} zIndex={zIndex} containerTop={containerTop}
    containerBottom={containerBottom} {...rest}>
    {children}
  </ContainerElement>);

if (process.env.NODE_ENV !== 'production') {
  UIContainer.propTypes = {
    paddingTop: PropTypes.string,
    position: PropTypes.string,
    zIndex: PropTypes.string,
    containerTop: PropTypes.string,
    containerBottom: PropTypes.string
  };
}

const ContainerElement = styled.div`
  ${props => props.paddingTop != null && `padding-top: ${props.paddingTop};`}
  ${props => props.position != null && `position: ${props.position};`}
  ${props => props.containerTop != null && `top: ${props.containerTop};`}
  ${props => props.containerBottom != null && `bottom: ${props.containerBottom};`}
  ${props => props.zIndex != null && `z-index: ${props.zIndex};`}
  display: block;
  max-width: 100% !important;
  @media only screen and (max-width: 767px) {
    width: auto !important;
    margin-left: ${CONTAINER_MOBILE_MARGIN}px !important;
    margin-right: ${CONTAINER_MOBILE_MARGIN}px !important;
  }
  @media only screen and (min-width: 768px) and (max-width: 991px) {
    width: ${CONTAINER_WIDTH_768}px;
    margin-left: auto !important;
    margin-right: auto !important;
  }
  @media only screen and (min-width: 992px) and (max-width: 1199px) {
    width: ${CONTAINER_WIDTH_992}px;
    margin-left: auto !important;
    margin-right: auto !important;
  }
  @media only screen and (min-width: 1200px) and (max-width: 1399px) {
    width: ${CONTAINER_WIDTH_1200}px;
    margin-left: auto !important;
    margin-right: auto !important;
  }
  @media only screen and (min-width: 1400px) and (max-width: 1599px) {
    width: ${CONTAINER_WIDTH_1400}px;
    margin-left: auto !important;
    margin-right: auto !important;
  }
  @media only screen and (min-width: 1600px) {
    width: ${CONTAINER_WIDTH_1600}px;
    margin-left: auto !important;
    margin-right: auto !important;
  }
`;

export default UIContainer;
